/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit'

export const restaurantSlice = createSlice({
  name: 'restaurant',
  initialState: {
    live: 'NOTACTIVE'
  },
  reducers: {
    SetRestaurantStatus: (state, action) => {
      state.live = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { SetRestaurantStatus } = restaurantSlice.actions

export default restaurantSlice.reducer
